import { CustomFieldProvider } from "@repo/app-types/entities/customField";
import type { InterviewLoaded } from "@repo/app-types/entities/interview";
import type { FC } from "react";
import { UserCustomFieldsSection } from "./userCustomFieldsSection.js";

interface InterviewUserCustomFieldsSectionProps {
  interview: InterviewLoaded;
}

export const InterviewUserCustomFieldsSection: FC<
  InterviewUserCustomFieldsSectionProps
> = ({ interview }) => {
  // Filter custom fields to only include user-defined ones
  const customFields = interview.custom_fields?.filter(
    (customField) => customField.provider === CustomFieldProvider.User,
  );

  return (
    <UserCustomFieldsSection
      label="Interview custom fields"
      customFields={customFields}
    />
  );
};
